
<template>
    <el-dialog title="更新密码" :visible.sync="dialogFormVisible2">
        <avue-form ref="updatePasswordForm" v-model="updatePasswordForm" :option="formOption">
            <template  slot="menuForm">
                <el-button  @click="handleEmpty">取 消</el-button>
                <el-button type="primary" @click="change_pwd">确 定</el-button>
            </template>
        </avue-form>
    </el-dialog> 
</template>
<script>
  import {changePwd} from '@/api/admin/user'
  import waves from '@/directive/waves/index.js' // 水波纹指令
  import {objKeySort} from '@/util/ajaxsign'
  import {validatePass,validatePass2} from "@/util/Format"
  export default {
    name: 'update_password',
    directives: {
      waves
    },
    data() {
      return {
        updatePasswordForm : {
          password:'',
          password1:'',
          userId:'',
        },
        formOption:{
            emptyBtn:false,
            submitBtn:false,
            submitText : '确定',
            column: [{
              label: "密码",
              prop: "password",
              type : "password",
              visdiplay : true,
              span:12,
              rules: [{ validator: validatePass, trigger: 'blur' }]
          },{
              label: "确认密码",
              prop: "password1",
              type : "password",
              visdiplay : true,
              span:12,
              rules: [{ validator: validatePass2, trigger: 'blur' }]
          }],
        },
        dialogFormVisible2 : false
      }
    },
    created() {
     
    },
    methods: {
      //设置用户id
      setuserid : function(data){
        this.updatePasswordForm.userId = data;
        this.dialogFormVisible2 = true;  
      },
      // 修改密码
      change_pwd(){
        this.$refs.updatePasswordForm.validate(vaild=>{
            if(vaild){
                  changePwd(objKeySort({userId:this.updatePasswordForm.userId,password:this.updatePasswordForm.password})).then(res => {
                    console.log(res);
                    this.$message({
                        title: '修改密码成功',
                        message: '修改密码成功',
                        type: 'success',
                        duration: 2000
                    })
                    window.sessionStorage.removeItem("password")
                    this.$emit('refresh','');
                    this.handleEmpty();
                    this.totalStatus = true;
                })
            }
        })
      },
      handleEmpty(){
        this.dialogFormVisible2 = false;
        this.$refs.updatePasswordForm.resetForm();
      },
    }
  }
</script>